import type { MainPageRemoteBlock } from './types'

export function parseBlockPayload<T = unknown> (block: MainPageRemoteBlock): T | null {
  try {
    return JSON.parse(block.payload)
  }
  catch {
    return null
  }
}
